var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-row",
    { staticClass: "expanded-row" },
    [
      _c(
        "b-col",
        { attrs: { sm: "6" } },
        [
          _vm.finding.vulnerability.aliases &&
          _vm.finding.vulnerability.aliases.length > 0
            ? _c(
                "div",
                [
                  _c("label", [_vm._v("Aliases")]),
                  _c(
                    "b-card",
                    { staticClass: "font-weight-bold" },
                    [
                      _c(
                        "b-card-text",
                        _vm._l(
                          _vm.resolveVulnAliases(
                            _vm.finding.vulnerability.aliases,
                            _vm.finding.vulnerability.source
                          ),
                          function (alias) {
                            return _c(
                              "span",
                              { key: alias.vulnId },
                              [
                                _c(
                                  "b-link",
                                  {
                                    staticStyle: { "margin-right": "1rem" },
                                    attrs: {
                                      href:
                                        "/vulnerabilities/" +
                                        alias.source +
                                        "/" +
                                        alias.vulnId,
                                    },
                                  },
                                  [_vm._v(_vm._s(alias.vulnId))]
                                ),
                              ],
                              1
                            )
                          }
                        ),
                        0
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm.finding.vulnerability.title
            ? _c(
                "b-form-group",
                {
                  attrs: {
                    id: "fieldset-1",
                    label: this.$t("message.title"),
                    "label-for": "input-1",
                  },
                },
                [
                  _c("b-form-input", {
                    staticClass: "form-control disabled",
                    attrs: {
                      id: "input-1",
                      value: _vm.finding.vulnerability.title,
                      readonly: "",
                      trim: "",
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm.finding.vulnerability.subtitle
            ? _c(
                "b-form-group",
                {
                  attrs: {
                    id: "fieldset-2",
                    label: this.$t("message.subtitle"),
                    "label-for": "input-2",
                  },
                },
                [
                  _c("b-form-input", {
                    staticClass: "form-control disabled",
                    attrs: {
                      id: "input-2",
                      value: _vm.finding.vulnerability.subtitle,
                      readonly: "",
                      trim: "",
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm.finding.vulnerability.description
            ? _c(
                "b-form-group",
                {
                  attrs: {
                    id: "fieldset-3",
                    label: this.$t("message.description"),
                    "label-for": "input-3",
                  },
                },
                [
                  _c("b-form-textarea", {
                    staticClass: "form-control disabled",
                    attrs: {
                      id: "input-3",
                      value: _vm.finding.vulnerability.description,
                      rows: "7",
                      readonly: "",
                      trim: "",
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm.finding.vulnerability.recommendation
            ? _c(
                "b-form-group",
                {
                  attrs: {
                    id: "fieldset-4",
                    label: this.$t("message.recommendation"),
                    "label-for": "input-4",
                  },
                },
                [
                  _c("b-form-textarea", {
                    staticClass: "form-control disabled",
                    attrs: {
                      id: "input-4",
                      value: _vm.finding.vulnerability.recommendation,
                      rows: "7",
                      readonly: "",
                      trim: "",
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm.finding.vulnerability.cvssV2Vector
            ? _c(
                "b-form-group",
                {
                  attrs: {
                    id: "fieldset-5",
                    label: this.$t("message.cvss_v2_vector"),
                    "label-for": "input-5",
                  },
                },
                [
                  _c("b-form-input", {
                    staticClass: "form-control disabled",
                    attrs: {
                      id: "input-5",
                      value: _vm.finding.vulnerability.cvssV2Vector,
                      readonly: "",
                      trim: "",
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm.finding.vulnerability.cvssV3Vector
            ? _c(
                "b-form-group",
                {
                  attrs: {
                    id: "fieldset-6",
                    label: this.$t("message.cvss_v3_vector"),
                    "label-for": "input-6",
                  },
                },
                [
                  _c("b-form-input", {
                    staticClass: "form-control disabled",
                    attrs: {
                      id: "input-6",
                      value: _vm.finding.vulnerability.cvssV3Vector,
                      readonly: "",
                      trim: "",
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
      _c(
        "b-col",
        { attrs: { sm: "6" } },
        [
          _c(
            "b-form-group",
            {
              attrs: {
                id: "fieldset-7",
                label: this.$t("message.audit_trail"),
                "label-for": "auditTrailField",
              },
            },
            [
              _c("b-form-textarea", {
                staticClass: "form-control disabled",
                attrs: {
                  id: "auditTrailField",
                  rows: "7",
                  readonly: "",
                  trim: "",
                },
                model: {
                  value: _vm.auditTrail,
                  callback: function ($$v) {
                    _vm.auditTrail = $$v
                  },
                  expression: "auditTrail",
                },
              }),
            ],
            1
          ),
          this.isPermitted(this.PERMISSIONS.VULNERABILITY_ANALYSIS)
            ? _c(
                "b-form-group",
                {
                  attrs: {
                    id: "fieldset-8",
                    label: this.$t("message.comment"),
                    "label-for": "input-8",
                  },
                },
                [
                  _c("b-form-textarea", {
                    staticClass: "form-control",
                    attrs: { id: "input-8", rows: "4", trim: "" },
                    model: {
                      value: _vm.comment,
                      callback: function ($$v) {
                        _vm.comment = $$v
                      },
                      expression: "comment",
                    },
                  }),
                  _c(
                    "div",
                    { staticClass: "pull-right" },
                    [
                      _c(
                        "b-button",
                        {
                          attrs: { size: "sm", variant: "outline-primary" },
                          on: { click: _vm.addComment },
                        },
                        [
                          _c("span", { staticClass: "fa fa-comment-o" }),
                          _vm._v(
                            "\n          " +
                              _vm._s(this.$t("message.add_comment"))
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          this.isPermitted(this.PERMISSIONS.VULNERABILITY_ANALYSIS)
            ? _c(
                "b-form-group",
                {
                  attrs: {
                    id: "fieldset-9",
                    label: this.$t("message.analysis"),
                    "label-for": "input-9",
                  },
                },
                [
                  _c(
                    "b-input-group",
                    { attrs: { id: "input-9" } },
                    [
                      _c("b-form-select", {
                        directives: [
                          {
                            name: "b-tooltip",
                            rawName: "v-b-tooltip.hover",
                            modifiers: { hover: true },
                          },
                        ],
                        staticStyle: {
                          flex: "0 1 auto",
                          width: "auto",
                          "margin-right": "2rem",
                        },
                        attrs: {
                          options: _vm.analysisChoices,
                          title: this.$t("message.analysis_tooltip"),
                        },
                        on: { change: _vm.makeAnalysis },
                        model: {
                          value: _vm.analysisState,
                          callback: function ($$v) {
                            _vm.analysisState = $$v
                          },
                          expression: "analysisState",
                        },
                      }),
                      _c("bootstrap-toggle", {
                        attrs: {
                          options: {
                            on: this.$t("message.suppressed"),
                            off: this.$t("message.suppress"),
                            onstyle: "warning",
                            offstyle: "outline-disabled",
                          },
                          disabled: _vm.analysisState === null,
                        },
                        model: {
                          value: _vm.isSuppressed,
                          callback: function ($$v) {
                            _vm.isSuppressed = $$v
                          },
                          expression: "isSuppressed",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          this.isPermitted(this.PERMISSIONS.VULNERABILITY_ANALYSIS)
            ? _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    { attrs: { sm: "6" } },
                    [
                      _c(
                        "b-form-group",
                        {
                          attrs: {
                            id: "fieldset-10",
                            label: this.$t("message.justification"),
                            "label-for": "input-10",
                          },
                        },
                        [
                          _c(
                            "b-input-group",
                            { attrs: { id: "input-10" } },
                            [
                              _c("b-form-select", {
                                directives: [
                                  {
                                    name: "b-tooltip",
                                    rawName: "v-b-tooltip.hover",
                                    modifiers: { hover: true },
                                  },
                                ],
                                attrs: {
                                  options: _vm.justificationChoices,
                                  disabled:
                                    _vm.analysisState === null ||
                                    _vm.analysisState !== "NOT_AFFECTED",
                                  title: _vm.$t(
                                    "message.justification_tooltip"
                                  ),
                                },
                                on: { change: _vm.makeAnalysis },
                                model: {
                                  value: _vm.analysisJustification,
                                  callback: function ($$v) {
                                    _vm.analysisJustification = $$v
                                  },
                                  expression: "analysisJustification",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "b-col",
                    { attrs: { sm: "6" } },
                    [
                      _c(
                        "b-form-group",
                        {
                          attrs: {
                            id: "fieldset-11",
                            label: this.$t("message.response"),
                            "label-for": "input-11",
                          },
                        },
                        [
                          _c(
                            "b-input-group",
                            { attrs: { id: "input-11" } },
                            [
                              _c("b-form-select", {
                                directives: [
                                  {
                                    name: "b-tooltip",
                                    rawName: "v-b-tooltip.hover",
                                    modifiers: { hover: true },
                                  },
                                ],
                                attrs: {
                                  options: _vm.responseChoices,
                                  disabled: _vm.analysisState === null,
                                  title: this.$t("message.response_tooltip"),
                                },
                                on: { change: _vm.makeAnalysis },
                                model: {
                                  value: _vm.analysisResponse,
                                  callback: function ($$v) {
                                    _vm.analysisResponse = $$v
                                  },
                                  expression: "analysisResponse",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          this.isPermitted(this.PERMISSIONS.VIEW_VULNERABILITY)
            ? _c(
                "b-form-group",
                {
                  attrs: {
                    id: "fieldset-12",
                    label: this.$t("message.details"),
                    "label-for": "analysisDetailsField",
                  },
                },
                [
                  _c("b-form-textarea", {
                    directives: [
                      {
                        name: "b-tooltip",
                        rawName: "v-b-tooltip.hover",
                        modifiers: { hover: true },
                      },
                    ],
                    staticClass: "form-control",
                    attrs: {
                      id: "analysisDetailsField",
                      rows: "7",
                      disabled:
                        _vm.analysisState === null ||
                        !this.isPermitted(
                          this.PERMISSIONS.VULNERABILITY_ANALYSIS
                        ),
                      title: this.$t("message.analysis_details_tooltip"),
                    },
                    model: {
                      value: _vm.analysisDetails,
                      callback: function ($$v) {
                        _vm.analysisDetails = $$v
                      },
                      expression: "analysisDetails",
                    },
                  }),
                  _c(
                    "div",
                    { staticClass: "pull-right" },
                    [
                      this.isPermitted(this.PERMISSIONS.VULNERABILITY_ANALYSIS)
                        ? _c(
                            "b-button",
                            {
                              attrs: {
                                disabled: _vm.analysisState === null,
                                size: "sm",
                                variant: "outline-primary",
                              },
                              on: { click: _vm.makeAnalysis },
                            },
                            [
                              _c("span", { staticClass: "fa fa-comment-o" }),
                              _vm._v(
                                "\n          " +
                                  _vm._s(this.$t("message.update_details"))
                              ),
                            ]
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }